import React from 'react'
import { createPortal } from 'react-dom'
import PropTypes from 'prop-types'

export default function PlayerTrackOverlay ({ player, tracks, seconds }) {
  if (!player || player.isDisposed() || !tracks.length) return null
  const video = player.el().querySelector('video')
  if (!video?.videoWidth) return null
  const width = video.videoWidth
  const height = video.videoHeight
  const observations = tracks.flatMap(track => {
    const sample = track.samples.find(sample => Math.abs(sample.seconds - seconds) <= 0.11)
    return sample ? [{ ...sample, id: track.track_id }] : []
  })
  return createPortal(<svg aria-label="AI player tracking" className="player-track-overlay" viewBox={`0 0 ${width} ${height}`} style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', pointerEvents: 'none' }}>
    {observations.map(sample => <g key={sample.id}>
      <rect x={sample.box[0] * width} y={sample.box[1] * height} width={sample.box[2] * width} height={sample.box[3] * height} fill="none" stroke="#35edc7" strokeWidth={Math.max(2, width / 600)} />
      <text x={sample.box[0] * width} y={Math.max(18, sample.box[1] * height - 6)} fill="#35edc7" stroke="#10231e" paintOrder="stroke" strokeWidth="2" fontSize={Math.max(14, width / 80)}>AI match</text>
    </g>)}
  </svg>, player.el())
}

PlayerTrackOverlay.propTypes = { player: PropTypes.object, tracks: PropTypes.array.isRequired, seconds: PropTypes.number }
